import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cee_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const PARTNER_DISABLED = "Votre espace partenaire est désactivé. Contactez Genis Energie.";

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const isLogin = error.config?.url?.includes("/auth/login");
    if (!isLogin && error.response?.status === 403 && error.response?.data?.detail === PARTNER_DISABLED) {
      localStorage.removeItem("cee_token");
      sessionStorage.setItem("cee_disabled", "1");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
